import React from 'react'
import injectSheet from 'react-jss'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'

export const ParentBackToWriting = injectSheet({
  '@keyframes appear': {
    to: {
      opacity: '1'
    }
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    textDecoration: 'none',
    fontWeight: 'bold',
    background: 'rgba(0, 0, 0, 0.15)',
    padding: '4px 10px',
    borderRadius: '4px',
    fontSize: '14px',
    color: '#fff',
    height: '40px',
    opacity: '0',
    animation: '.3s appear ease-out forwards'
  }
})(function ParentBackToWriting({ classes, className }) {
  return (
    <Link
      className={className ? `${classes.link} ${className}` : classes.link}
      to="/parent/saved">
      <FontAwesomeIcon icon={faAngleLeft} />
      Back to my writing
    </Link>
  )
})
